export const PRODUCTION_PQL_FORM_ATTRIBUTES = {
  formId: '5ae29a72-cc99-4702-9bcc-936891469830',
  portalId: '53'
};
export const QA_PQL_FORM_ATTRIBUTES = {
  formId: '479b8d6d-b9b2-4941-b16a-74d2cef76778',
  portalId: '99609805'
};